import { AuthScreen } from "@/interactors/AuthScreen";

export default function Auth() {
  return <AuthScreen />;
}
